import {
  ConstraintCategory,
  ConstraintCategoryType,
  INFEASIBLE_RUN_STATUS
} from './constraint-diagnostics-constants';

export const formatConstraintAmount = (
  amount: number,
  category: ConstraintCategoryType
): string => {
  const value = amount.toLocaleString('en-US', { maximumSignificantDigits: 12 });
  return category === ConstraintCategory.BUDGET ? `$${value}` : `${value} rule units`;
};

export const formatOptimizationStatus = (status: string, progress?: number): string => {
  if (status === INFEASIBLE_RUN_STATUS) return 'No valid plan found';
  if (status.startsWith('FAIL')) return status;
  if (status.startsWith('SUCC')) return 'Success';
  return typeof progress === 'number' && Number.isFinite(progress)
    ? `${status} (${Math.round(progress > 1 ? progress : progress * 100)}%)`
    : status;
};
